<template>
  <div class="container-login">
    <div class="container-dados">
      <div class="container">
        <div class="row justify-content-center align-items-center">
          <div class="col-md-6 col-lg-5 text-center d-none d-md-block">
            <div class="logo-lecard"><img src="../assets/logo.png" alt="Logo LeCard"></div>
          </div>
          <div class="col-md-6 col-lg-5">
            <div class="card shadow-sm border mx-auto" style="max-width: 360px">
              <div class="card-body">
                <div class="badge badge-primary float-right" v-if="isHomolog">Modo Dev</div>
                <div class="mb-4"><img src="../assets/logo.png" alt="Logo LeCard" style="width: 32px;"></div>
                <div v-if="step === 3">
                  <auth2 @voltar="voltar" @auth="logar" :telefone="telefone" :error="error" :load="load"/>
                </div>
                <div v-else>
                  <h5 class="mb-1">Login</h5>
                  <div class="mb-3">
                    <div class="mb-0" v-if="step === 1">Informe seu usuário de acesso</div>
                    <div class="mb-0" v-else>{{dados.email}} <a href="javascript:" class="small login-change-link" @click="voltar(1)">(Alterar)</a></div>
                  </div>
                  <div>
                    <form @submit.prevent="logar()">
                      <div class="form-group" v-if="step === 1">
                        <input type="email" id="usuario" v-model="dados.email" class="form-control" placeholder="Usuário ou E-mail" minlength="4" :disabled="load" required>
                      </div>
                      <div class="form-group input-senha" v-else>
                        <input :type="showPassword ? 'text' : 'password'" id="inputSenha" class="form-control" v-model="dados.senha" placeholder="Digite sua senha" autocomplete="password" :disabled="load" required>
                        <i class="fa-solid" :class="showPassword ? 'fa-eye-slash' : 'fa-eye'" @click="mostrarSenha()" v-show="dados.senha.length > 0"
                           :title="showPassword ? 'Esconder senha' : 'Mostrar senha'"></i>
                      </div>
                      <div class="alert-error small" v-if="error">{{ error }}</div>
                      <button class="btn btn-primary btn-block py-2" :disabled="load">{{load ? 'Aguarde' : 'Continuar'}}</button>
                      <div class="text-center mt-4 mb-3">
                        <p class="mb-0" v-if="step === 1"><a class="login-help-link" href="https://lecard.tawk.help/article/como-encontrar-meu-usuario" target="_blank">Não sei meu usuário</a></p>
                        <a href="javascript:" class="login-forgot-link text-decoration-none" @click="recuperarSenha()" v-else>Esqueceu a senha?</a>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-botton text-white">
      <div class="container pb-3 text-center">
        <p class="m-0 small">&copy; {{ currentYear }} <b>LeCard</b>. Todos os direitos reservados.</p>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import Auth2 from "@/components/Auth2";
export default {
  name: 'Login',
  components: {Auth2, Loading},
  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem('key')) {
      next({ path: '/pedidos', replace: true });
      return;
    }

    next();
  },
  data() {
    return {
      load: false,
      showPassword: false,
      step: 1,
      currentYear: new Date().getFullYear(),
      telefone: '',
      error: '',
      dados: {
        pin: '',
        email: '',
        senha: ''
      }
    }
  },

  methods: {
    logar(pin) {
      this.dados.pin = "";

      switch (this.step) {
        case 1:
          this.dados.senha = "";
          break;

        case 3:
          this.dados.pin = pin || "";
          break;
      }

      this.error = "";
      this.load = true;
      this.$http.post(this.base_server + 'auth/v2/login', this.dados)
          .then(res => {
            const data = res.data || {};

            if (!data.success || data.id_funcao !== '5') {
              this.error = "Este usuário não tem acesso nesta plataforma!";
              this.load = false;
              return;
            }

            if (data.token) {
              localStorage.setItem("key", data.token);
              localStorage.setItem("email", this.dados.email);

              if (data.x_auth) {
                localStorage.setItem('x_auth', data.x_auth);
              } else {
                localStorage.removeItem('x_auth');
              }

              window.location.reload();

            } else if (data.sem_senha) {
              sessionStorage.setItem('sem_senha', this.dados.email)
              this.$router.push('/recuperar');

            } else {
              this.load = false;
              this.telefone = data.telefone;

              if (data.step === 2) {
                this.step = 3;

              } else if (this.step === 1) {
                this.step = 2;
                this.$nextTick(() => {
                  this.$helpers.focusElement('inputSenha');
                });
              }
            }

          }, res => {
            this.load = false;

            if (!res.status) {
              const msg = this.$helpers.verificarServerAlternativo(true);
              this.$swal(msg);

            } else {
              const data = res.data || {};
              this.error = data.msg ? data.msg : 'Erro temporário';

              if (res.status === 401) {
                this.$helpers.focusElement(this.step === 3 ? 'validar_cod_pin' : (this.step === 1 ? 'usuario' : 'inputSenha'));
              }
            }
          });
    },

    voltar() {
      this.step = 1;
      this.dados.pin = "";
      this.error = "";
      this.$nextTick(() => {
        this.$helpers.focusElement('usuario');
      });
    },

    mostrarSenha() {
      this.showPassword = !this.showPassword;
    },

    recuperarSenha() {
      sessionStorage.setItem('recuperar', this.dados.email)
      this.$router.push('/recuperar');
    }
  },

  mounted() {
    if (localStorage.getItem("email")) {
      this.dados.email = localStorage.getItem("email");
      this.$helpers.focusElement('inputSenha');

    } else {
      this.$helpers.focusElement('usuario');
    }
  }
}
</script>

<style scoped>
.container-login {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  padding-top: var(--safe-area-inset-top, env(safe-area-inset-top, 0));
  padding-bottom: var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0));
}
.container-botton {
  width: 100%;
  flex: 0 0 auto;
}
.container-dados {
  flex: 1 0 auto;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 48px 0;
}
.logo-lecard img {
  width: 300px;
  object-fit: cover;
}

.dark-mode .logo-lecard img {
  filter: none;
}

.dark-mode .card-body > .mb-4 img {
  filter: none;
}

.dark-mode img {
  filter: invert(100%);
}

.login-help-link {
  color: #000000;
}

.login-change-link {
  color: #2f6b1f;
}

.login-forgot-link {
  color: #000000;
}

.dark-mode .login-help-link {
  color: var(--text-default);
}

.dark-mode .login-change-link,
.dark-mode .login-forgot-link {
  color: var(--primary);
}

.container-login .form-control:focus,
.container-login .form-control:active,
.container-login .form-control:hover {
  outline: none !important;
  border-color: var(--border-color) !important;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}

.container-login .form-control {
  -webkit-appearance: none;
  appearance: none;
  outline: none;
  -webkit-tap-highlight-color: transparent;
}

@media (max-width: 767px) {
  .container-dados {
    padding-top: 0;
  }
}

@media (max-height: 550px) {
  .container-dados {
    padding: 48px 0;
  }
}
</style>
